import React from "react";

const PageHead = ({ title, subtitle, actions }) => (
  <section className="page-head">
    <div>
      <h1>{title}</h1>
      {subtitle && <div className="page-head__sub">{subtitle}</div>}
    </div>
    {actions && <div className="page-head__actions">{actions}</div>}
  </section>
);

export default PageHead;
